export const LAYER_NOTES = {
  'Si die': {
    heading: 'Silicon',
    body: 'CTE ≈ 2.6 ppm/K, E ≈ 130–170 GPa. It barely shrinks on cool-down. You do not “fix warpage” by changing the die CTE. You change who is allowed to shrink around it. Thinning the die reduces its stiffness (∝ t³) so the mold and copper win the fight — bow often gets worse, not better.',
  },
  'Die attach': {
    heading: 'Die attach',
    body: 'Soft, high-CTE epoxy (often 40–80+ ppm/K, E of a few GPa or less). It is a shear layer. Lower E uncouples die from leadframe and can cut die stress — and can also let the mold dominate the beam. Fillets, voiding, and bleed change the real stiffness. This 1D beam has no fillet.',
  },
  'Cu leadframe': {
    heading: 'Copper leadframe',
    body: 'CTE ≈ 17 ppm/K, E ≈ 110–130 GPa. For QFN / SO it is the backbone. Thickness and remaining copper after etch set EI. A half-etched pad is not the rectangle you see here.',
  },
  'EMC mold': {
    heading: 'EMC',
    body: 'Filled epoxy. Below Tg, CTE is often ~8–16 ppm/K and E tens of GPa; above Tg both move. Cool-down from mold (~170–180 °C) to 25 °C is not a single CTE — you cross Tg. This bench uses one effective CTE. Chemical shrinkage at gel is extra moment this model does not have. Moisture later swells the mold and can flatten or reverse the cup (the “smiling / crying” map after MSL + reflow).',
  },
};

export const WARPAGE_NOTES = [
  {
    heading: 'What you are actually computing',
    body: [
      'A multilayer Euler beam. Each layer wants ε = α ΔT. The stack is forced to one curvature κ so that net force is zero and net moment balances. Centre bow on a simply supported strip is δ = κ L² / 8. Display is exaggerated so you can see the cup; the micrometre number is the model, not the drawing.',
    ],
    list: [
      'ΔT < 0 is cool-down from mold/post-mold cure toward room temperature.',
      'Sign: high-CTE layers on one side of the neutral axis pull that face shorter when they cool.',
      'Die bending stress here is E_si · κ · (z_die − z_n). Order-of-magnitude only — no crystal orientation, no edge singularity.',
    ],
  },
  {
    heading: 'Typical numbers on a back-end line',
    body: [
      'Mold and PMC are often in the 170–180 °C class. Room is ~25 °C, so |ΔT| ~ 150 K is the first cool-down you should have in your head. Body sizes from a few millimetres to ~10–12 mm for QFN-like; a 100 mm strip is a coupon, not a unit, so you scale bow with L².',
    ],
    list: [
      'Si 2.6 ppm/K · Cu 17 · many EMCs 10–20 below Tg · DA epoxies much higher.',
      'Assembly cares about coplanarity at the leads/pads, not poetry at the die centre. A “watch” bow on a coupon can still fail a 0.08 mm coplanarity window on a real map.',
      'Wirebond likes a stable, not too convex, die surface. SMT likes a flat lead plane. Those two wants fight.',
    ],
  },
  {
    heading: 'What to change Monday (and what not to)',
    body: [
      'If bow is too high after cool-down: first check EMC thickness and Tg/CTE, then leadframe remaining copper, then die thickness. Do not start with a new silicon CTE. A softer DA can drop die stress while letting mold run the beam — you must say which failure you are buying.',
    ],
    list: [
      'Thin die → lower EI of the stiff low-CTE member → mold/copper often bow more.',
      'Thicker EMC → more moment and more EI; direction depends where the mold sits vs z_n.',
      'The real next measurement is a warpage map vs temperature (shadow moiré / digital image correlation), not another argument in the aisle.',
    ],
  },
  {
    heading: 'Where this model is a lie',
    body: [
      'It is 1D, isothermal, elastic, one CTE, no moisture, no viscoelasticity, no die shadow, no half-etch, no mold flash. Real packages are plates with a die island. Corners lead. Reflow can invert the shape. Use this to know which lever exists — then measure the map.',
    ],
  },
];
